import { ProductType } from './product-type';

export const QuestionnaireType = Object.freeze({
  business: 'business',
  governmentBacked: 'introducer-government-backed',
  introducer: 'introducer',
  introducerRecoveryLoanScheme: 'introducer-recovery-loan-scheme',
  introducerWorkingCapital: 'introducer-working-capital',
  introducerCreditImprovement: 'introducer-credit-improvement',
  introducerRecovery: 'introducer-debt-recovery',
  introducerProperty: 'introducer-commercial-property',
  introducerGrants: 'introducer-grants',
  introducerAllFundingProducts: 'introducer-all-funding-products',
  introducerRdTaxClaim: 'introducer-rd-tax-claim',
  businessCreditReviewByIntroducer: 'business-credit-review-by-introducer',

  businessWorkingCapital: 'business-working-capital',
  businessCreditImprovement: 'business-credit-improvement',
  businessAnonymousWorkingCapital: 'business-anonymous-working-capital',
  businessCreditReview: 'business-credit-review',
  businessProperty: 'business-commercial-property',
});

export const QuestionnaireTypeByProductType = Object.freeze({
  [ProductType.recoveryLoanScheme]: QuestionnaireType.introducerRecoveryLoanScheme,
  [ProductType.termLoans]: QuestionnaireType.introducerWorkingCapital,
  [ProductType.commercialProperty]: QuestionnaireType.introducerProperty,
  [ProductType.assetBackedFinance]: QuestionnaireType.introducerAllFundingProducts,
  [ProductType.invoiceFinancing]: QuestionnaireType.introducerAllFundingProducts,
  [ProductType.tradeFinance]: QuestionnaireType.introducerAllFundingProducts,
  [ProductType.merchantCashAdvance]: QuestionnaireType.introducerAllFundingProducts,
  [ProductType.grants]: QuestionnaireType.introducerGrants,
  [ProductType.debtRecovery]: QuestionnaireType.introducerRecovery,
  [ProductType.grants]: QuestionnaireType.introducerGrants,
  [ProductType.creditImprovement]: QuestionnaireType.introducerCreditImprovement,
  [ProductType.researchAndDevelopmentTax]: QuestionnaireType.introducerRdTaxClaim,
  [ProductType.businessProperty]: QuestionnaireType.businessProperty,
});
